import Button from '@mui/material/Button';
import React from "react";
import {useDispatch, connect} from 'react-redux';
import Paper from "@mui/material/Paper";
import AddIcon from '@mui/icons-material/Add';
import Typography from "@mui/material/Typography";
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import ColorRamp from './ColorRamp';

const mapStateToProps = state => {
    return {
        map: state.MapReducer
    }
};

const ColorGroupSelector = (props) => {
    let colorRamps = (props.map.colorRamps);
    
    return <Select style={{backgroundColor:'#ffffff'}}
        size='small'
        value={props.colorRamp}
        onChange={(e)=>{
            props.onChange(e.target.value)
        }}
    >
        {
            Object.keys(colorRamps).map(k=>{
                let lo = colorRamps[k];
                return (
                    <MenuItem value={lo.name}>
                        <ColorRamp colorRamp={lo.colors} />
                    </MenuItem>
                )
            })
        }
    </Select>
}

export default connect(mapStateToProps)(ColorGroupSelector);